/*
 * Name: Image List
 * Desc:
 *
 */
import React, { useEffect, useState } from "react"
import { Image } from "react-datocms"
import InfiniteScroll from "react-infinite-scroller"
import Link from "next/link"
import ProductCard from "../ProductCard/ProductCard"
import * as styles from "./ProductList.module.scss"
import useMediaQuery from "@lib/useMediaQuery"
import FetchSpinner from "@components/global/FetchSpinner/FetchSpinner"
import FetchSpinnerCard from "@components/global/FetchSpinner/FetchSpinnerCard"
import Button from "@components/objects/Button/Button"

const ProductList = (props) => {
  // Resize control
  const isMobile = useMediaQuery(1100)

  const emptyState = props.empty ? (
    <div className={`${styles.empty}`}>
      <div className={styles.image}>
        <img src={isMobile ? props.empty.backgroundImage.mobile : props.empty.backgroundImage.desktop} />
        <div className={styles.overlay}>
          <div className={styles.text}>
            {props.empty.title && <h2>{props.empty.title}</h2>}
            <p>{props.empty.text}</p>

            <Button text={props.empty.btnLabel} onClick={props.clearAllFilters} />
          </div>
        </div>
      </div>

      {props.empty.extra && (
        <div className={styles.extra}>
          <a target="_blank" href={props.empty.extra.link} rel="noreferrer">
            <p>{props.empty.extra.text}</p>
          </a>
        </div>
      )}
    </div>
  ) : null

  const products =
    props.products && props.products.length
      ? props.products.map((product) => <ProductCard key={product.id} isMobile={isMobile} {...product} />)
      : null

  const productsSection =
    products && products.length ? (
      <InfiniteScroll
        className={styles.ProductList}
        useWindow
        pageStart={0}
        loadMore={props.loadFunc ? props.loadFunc : () => true}
        hasMore={props.hasMore}
        initialLoad={false}
        loader={props.hasMore && <FetchSpinner />}
      >
        {products}
      </InfiniteScroll>
    ) : null

  // while suppliers haven't been fetched show spinner if results return with 0 show emptystate otherwise load supplier section
  if (props.products) {
    if (props.products.length === 0) {
      return emptyState
    }
    if (props.products.length) {
      return productsSection
    }
    return <FetchSpinnerCard view="portrait" type="product" />
  }
  return <FetchSpinnerCard view="portrait" type="card" />
}

export default ProductList
